import { get } from "../methods";
function getCompanyIndustryAverage_default(lookup) {
  return get({
    url: `api/industry/company/${lookup}`
  });
}
export {
  getCompanyIndustryAverage_default as default
};
